/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTScrollable } from './scrollable';
export type {
	KTScrollableConfigInterface,
	KTScrollableInterface,
} from './types';
